import { zodResolver } from "@hookform/resolvers/zod";
import { forwardRef } from "react";

import { defaultTravelPersonalFormValues } from "@/D2C/features/travel-quote/redux/travel-quote/travelQuoteSlice";
import type { SharedPersonalAutofillValues } from "@/shared/stepper/PersonalDetailsFormStep";
import { PersonalDetailsFormStep } from "@/shared/stepper/PersonalDetailsFormStep";
import type { StepFormComponentProps, StepFormHandle } from "@/shared/stepper/types";
import { personalDetailsSchema } from "@/shared/validation/travelQuoteSchemas";
import { TravelPersonalFormValues } from "../../redux/type";

export const PersonalDetailsStep = forwardRef<
  StepFormHandle<TravelPersonalFormValues>,
  StepFormComponentProps<
    TravelPersonalFormValues,
    {
      autofillValues?: SharedPersonalAutofillValues;
      autofillVersion?: number;
      layoutClassName?: string;
      showAdditionalFields?: boolean;
      onValuesChange?: (values: TravelPersonalFormValues) => void;
      onDemoDataClick?: () => void;
      isReadOnly?: boolean;
    }
  >
>(function PersonalDetailsStep(
  {
    defaultValues,
    autofillValues,
    autofillVersion,
    layoutClassName,
    showAdditionalFields,
    onValuesChange,
    onDemoDataClick,
    isReadOnly,
  },
  ref
) {
  // console.log("ALL PROPS", { defaultValues, autofillValues, autofillVersion, layoutClassName });

  return (
    <PersonalDetailsFormStep
      ref={ref}
      defaultValues={defaultValues as any}
      resolver={zodResolver(personalDetailsSchema) as any}
      fallbackValues={defaultTravelPersonalFormValues as any}
      autofillValues={autofillValues}
      autofillVersion={autofillVersion}
      layoutClassName={layoutClassName}
      showAdditionalFields={showAdditionalFields}
      onValuesChange={onValuesChange as any}
      onDemoDataClick={onDemoDataClick}
      isReadOnly={isReadOnly}
    />
  );
});
